import { useCallback, useState } from 'react';

const defaultState = {
    open: false,
    title: 'Confirm',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    danger: false,
    resolve: null
};

const useConfirm = () => {
    const [state, setState] = useState(defaultState);

    const confirm = useCallback((options = {}) => {
        return new Promise((resolve) => {
            setState({
                ...defaultState,
                ...options,
                open: true,
                resolve
            });
        });
    }, []);

    const handleClose = useCallback((result) => {
        setState((prev) => {
            if (prev.resolve) prev.resolve(result);
            return { ...defaultState };
        });
    }, []);

    return { confirm, confirmState: state, handleClose };
};

export default useConfirm;
